import { getConfig } from '@/config'

/**
 * 根据不同的运行环境，获取永久存储
 * @param key
 * @returns
 */
function getLocalStorage(key: string, isParse: boolean = false) {
  const prefix = getConfig().projectName + '_'
  let value = window.localStorage.getItem(prefix + key) || ''

  if (isParse && value) {
    return JSON.parse(value)
  }
  return value
}

/**
 * 根据不同的运行环境，获取临时存储
 * @param key
 * @returns
 */
function getSessionStorage(key: string, isParse: boolean = false) {
  const prefix = getConfig().projectName + '_'
  let value = window.sessionStorage.getItem(prefix + key) || ''

  if (isParse && value) {
    return JSON.parse(value)
  }
  return value
}

/**
 * 根据不同的运行环境，设置永久存储
 * @param key
 * @returns
 */
function setLocalStorage(key: string, value: any) {
  const prefix = getConfig().projectName + '_'
  if (typeof value !== 'string') {
    value = JSON.stringify(value)
  }

  window.localStorage.setItem(prefix + key, value)
}

/**
 * 根据不同的运行环境，设置临时存储
 * @param key
 * @returns
 */
function setSessionStorage(key: string, value: any) {
  const prefix = getConfig().projectName + '_'
  if (typeof value !== 'string') {
    value = JSON.stringify(value)
  }

  window.sessionStorage.setItem(prefix + key, value)
}

/**
 * 根据不同的运行环境，移除某一项存储
 * @param key
 */
function removeLocalStorage(key: string) {
  const prefix = getConfig().projectName + '_'
  window.localStorage.removeItem(prefix + key)
}

/**
 * 根据不同的运行环境，移除某一项存储
 * @param key
 */
function removeSessionStorage(key: string) {
  const prefix = getConfig().projectName + '_'
  window.sessionStorage.removeItem(prefix + key)
}

// 清除全部 localStorage 缓存数据
function clearAllStorage() {
  window.localStorage.clear()
}

// 清除全部 sessionStorage 缓存数据
function clearAllSessionStorage() {
  window.sessionStorage.clear()
}

export default {
  getLocalStorage,
  setLocalStorage,
  removeLocalStorage,
  getSessionStorage,
  setSessionStorage,
  removeSessionStorage,
  clearAllStorage,
  clearAllSessionStorage,
}
